export class UtilFormat {

    constructor() {}

    static formatMoney(n: any): string {
        var val = n.toString();
        var parseNumber: number = parseInt(val);
        const formatter = new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0   
        });
        const valFormatter = formatter.format(parseNumber);        
        if(parseNumber > 999 && parseNumber < 9999){
            return `${valFormatter.substring(0,3)}${valFormatter.substring(3)}`;
        }
        return valFormatter;
    }

    static formatDate(date: string) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();            
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;    
        return [year, month, day].join('-');
    }
 
}